<template>
  <div>
    <DataTable
      :headers="headers"
      :data="costs"
      :items-per-page="10"
      :buttons="buttons"
      :tableActions="tableActions"
    >
    </DataTable>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import DataTable from "@/components/cards/DataTable.vue";

export default {
  components: {
    DataTable,
  },
  data() {
    return {
      headers: [
        { field: "reference", label: "Référence", class: "" },
        { field: "fullName", label: "Nom complet", class: "" },
        { field: "tva", label: "TVA %", class: "" },
        { field: "remark", label: "Remarque", class: "" },
      ],
      buttons: [
        {
          label: "Modifier",
          icon: "bi bi-pencil",
          class: "btn btn-warning",
          action: (cost) => {
            this.$router.push({
              name: "costs-edit",
              params: { reference: cost.reference },
            });
          },
        },
        {
          label: "Détails",
          icon: "bi bi-info-square",
          class: "btn btn-primary",
          action: (cost) => {
            this.$router.push({
              name: "costs-details",
              params: { reference: cost.reference },
            });
          },
        },
        {
          label: "Supprimer",
          icon: "bi bi-trash",
          class: "btn btn-danger",
          action: (cost) => {
            this.deleteCost(cost);
          },
        },
      ],
      tableActions: [
        {
          title: "Actualiser",
          icon: "bi bi-arrow-clockwise",
          class: "btn btn-secondary",
          action: () => this.refresh(),
        },
        {
          title: "Créer",
          icon: "bi bi-plus-square",
          class: "btn btn-primary",
          action: () => this.$router.push({ name: "costs-create" }),
        },
      ],
    };
  },
  computed: {
    ...mapGetters("cost", {
      costs: "getAll",
    }),
  },
  mounted() {
    this.$store.dispatch("cost/getAll");
  },
  methods: {
    async refresh() {
      await this.$store.dispatch("cost/getAll");
    },
    async deleteCost(cost) {
      const confirmed = await this.$confirm({
        title: `Supprimer le coût ?`,
        message: `Vous voulez supprimer le coût ${cost.fullName} ?`,
        button: {
          no: "Non",
          yes: "Oui",
        },
      });
      if (confirmed) {
        await this.$store.dispatch("cost/destroy", cost.reference);
        await this.refresh(); // Refresh the list after deletion
      }
    },
  },
};
</script>

